<template lang="pug">
  .home
    Jumbo
    .text
      p Historias de esfuerzo, de innovación y superación son las que, desde el año 2005, BancoEstado ha premiado año a año gracias al Premio al Emprendedor, un reconocimiento que este año ya va en su edición número 14 y que ha ido evolucionando junto con la forma de emprender en Chile.
      p Se trata del premio de esta naturaleza con más años en Chile, y desde su creación ha recibido más de 730 mil postulaciones, las que han terminado premiando a 444 emprendedores en un proceso intenso y nada fácil. Cada año, el jurado compuesto por colaboradores y autoridades del banco, representantes gremiales y gubernamentales —que incluye a ministros de varias carteras, como José Ramón Valente de Economía; Felipe Larraín de Hacienda e Isabel Plá del ministerio de la Mujer y la Equidad de Género—escoge a las 48 empresas destacadas de un total de 24 mil postulaciones realizadas este año.
      p Desde sus inicios, este concurso abierto a micro y pequeñas empresas de todo el país, independiente de si son o no clientes del banco, ha premiado a emprendedores con vehículos de transporte y premios en dinero que suman un total de 1.265 millones de pesos.
      p El Premio al Emprendedor no es solo un concurso de popularidad. Con el tiempo se ha ido encargando de reflejar de manera vívida el cambiante mundo del emprendimiento nacional. Por ejemplo, desde  2012 cada categoría tiene un ganador hombre y otra mujer. Además, desde 2013 se agregaron los premios regionales, que aseguran que al menos dos de los reconocimientos sean a MIPES de regiones.
      p En cada versión del premio se entregan reconocimientos en dos categorías principales: Emprendedor Destacado, que se elige de un pool de subcategorías que incorporan diversos rubros como Transporte, Comercio y Servicios, y Agricultura, Pesca y Turismo; también, el de Emprendimiento Innovador, pensado para reconocer a quienes a través de ideas frescas y disruptivas tienen el potencial de transformar el mercado.
    Looper(:articles="articles")
</template>
<script>
import { mapState } from 'vuex'
import Jumbo from '@/components/Jumbo'
import Looper from '@/components/Looper'
export default {
  components: {
    Jumbo,
    Looper
  },
  computed: {
    ...mapState([
      'articles'
    ])
  }
}
</script>
<style lang="scss" scoped>
  .text{
    p{
      &:first-child{
        text-indent: 0;
        &:first-letter{
          // color: #e4a612;
          float: left;
          text-transform: uppercase;
          font-weight: 900;
          font-size: 4.8rem;
          text-transform: uppercase;
          line-height: 3.1rem;
          padding-top: 4px;
          padding-right: 3px;
          margin-left: -6px;
          font-family: 'Playfair Display', sans-serif;
        }
      }
    }
  }
</style>

